import { NgModule } from '@angular/core';
import { UtilComponentModule } from '../../components/util/util-component.module';
import { ImageModule } from '../../image-module/image.module';
import { MaterialModule } from '../../material.module';
import { CanvasService } from '../../services/canvas/canvas.service';
import { ControlPanelComponent } from './control-panel-component/control-panel.component';
import { UtilityControlPanelComponent } from './utility-control-panel/utility-control-panel.component';
import { BaseShapeControlPanelComponent } from './base-shape-control-panel/base-shape-control-panel.component';
import { ShapeFeatureControlPanelComponent } from './shape-feature-control-panel/shape-feature-control-panel.component';
import { StateControllerComponent } from './state-controller/state-controller.component';
import { FormsModule } from '@angular/forms';
import { CanvasControlPanelComponent } from './canvas-control-panel/canvas-control-panel.component';
import { FontFamilySelectorComponent } from './canvas-control-panel/text/font-family-selector/font-family-selector.component';
import { FontService } from './canvas-control-panel/text/font.service';
import { FontAlignSelectorComponent } from './canvas-control-panel/text/font-align-selector/font-align-selector.component';
import { LineHeightSelectorComponent } from './canvas-control-panel/text/line-height-selector/line-height-selector.component';
import { FillColorSelectorComponent } from './canvas-control-panel/text/fill-color-selector/fill-color-selector.component';
import { StrokeSelectorComponent } from './canvas-control-panel/text/stroke-selector/stroke-selector.component';
import { ColorPickerModule } from 'ngx-color-picker';
import { FontWeightSelectorComponent } from './canvas-control-panel/text/font-weight-selector/font-weight-selector.component';
import { CommonModule } from '@angular/common';
import { NewElementComponent } from './new-element.component';

@NgModule({
  declarations: [
    ControlPanelComponent,
    UtilityControlPanelComponent,
    BaseShapeControlPanelComponent,
    ShapeFeatureControlPanelComponent,
    StateControllerComponent,
    CanvasControlPanelComponent,
    FontFamilySelectorComponent,
    FontAlignSelectorComponent,
    LineHeightSelectorComponent,
    FillColorSelectorComponent,
    StrokeSelectorComponent,
    FontWeightSelectorComponent,
    NewElementComponent,
  ],
  imports: [
    CommonModule,
    ImageModule,
    UtilComponentModule,
    MaterialModule,
    FormsModule,
    ColorPickerModule,
  ],
  providers: [CanvasService, FontService],
  exports: [
    ControlPanelComponent,
    UtilityControlPanelComponent,
    BaseShapeControlPanelComponent,
    ShapeFeatureControlPanelComponent,
    CanvasControlPanelComponent,
    NewElementComponent,
    FontFamilySelectorComponent,
  ],
})
export class ControlerPanelModule {}
